import React, { useState, useEffect } from "react";
import "../CSS/style.css";
import { useNavigate, Link } from "react-router-dom";
import { useLocation } from "react-router-dom";
import axios from "axios";
import strings from "../String";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const EmailConfirmation = () => {
  let query = useQuery();
  let emailId = query.get("email");
  let token = query.get("token");

  const [isValidEmail, setIsValidEmail] = useState(false);

  useEffect(() => {
    let checkTheme = document.getElementById("root");
    if (checkTheme.classList.contains("dark-mode")) {
      checkTheme.classList.remove("dark-mode");
    }
    handleConfirmEmail();
  }, []);

  const handleConfirmEmail = async (e) => {
    //e.preventDefault();
    try {
      const response = await axios.get(
        `${strings.apiBaseUrl}/Login/confirmEmail`,
        {
          params: {
            email: emailId,
            token: token,
          },
        }
      );

      setIsValidEmail(true);
      //   if (response.data && response.data.token) {
      //     //alert('Login successful!');
      //     // Store the token in localStorage or sessionStorage if necessary
      //     sessionStorage.setItem('token', response.data.token);
      //     sessionStorage.setItem('EmailID', response.data.token);
      //     console.log('LoginPage',response.data.token);

      //   }
    } catch (error) {
      //   console.log(error);
      //   if(error.response.data.message=='Invalid email or password'){
      //     alert('Invalid email or password.');
      //   }
      //   if(error.response.data.message=='Email not confirmed'){
      //     alert('Email not confirmed.');
      //   }

      setIsValidEmail(false);
    }
  };

  return (
    <div>
      {isValidEmail ? (
        <p>Email Confirmed Successfully.</p>
      ) : (
        <p>Email Confirmation Failed.</p>
      )}
    </div>
  );
};

export default EmailConfirmation;
